import { Environment } from '@dice/app/types/env.type';
import { INT_ENV_CONFIG } from '@dice/environments/int/int.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const INT_STABLE_ENV_CONFIG: Environment = {
  ...INT_ENV_CONFIG,
  hostNames: ['buda-pre.swisscom.com', 'dice-pre.scapp-corp.swisscom.com', 'buda-pre.corproot.net', 'localhost:2000'],
  enableDebugInfo: false,
  isProduction: true,
  variant: 'dice-ui-int',
  logLevel: NgxLoggerLevel.OFF,
};
